export const queryATSProcessingsByStatusCreatedDateIndex = `
query QueryATSProcessingsByStatusCreatedDateIndex(
  $status: String!
  $first: Int
  $after: String
) {
  queryATSProcessingsByStatusCreatedDateIndex(
    status: $status
    first: $first
    after: $after
  ) {
    items {
      id
      alertSent
      atsType
      companyId
      companyName
      createdDate
      endDate
      logs
      status
      startDate
      syncType
      processName
      processId
      processTime
      processTimeInQueue
      result
    }
    nextToken
  }
}
`;